import React, { useState, useEffect } from 'react';
import {
    Grid,
    Menu,
    MenuItem,
    TextField,
    Typography,
    InputLabel,
    Box,
    Button,
    Card,
    Select,
    Icon,
    Link,
} from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import SimpleFooter from "examples/Footers/SimpleFooter";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import routes from "trainingCompanyRoutes";
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import Container from "@mui/material/Container";
import MKTypography from "components/MKTypography";
import Autocomplete from '@mui/material/Autocomplete';
import CountryList from 'country-list-with-dial-code-and-flag';
import SearchIcon from "@mui/icons-material/Search";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import MKAvatar from "components/MKAvatar";
import FormControl from '@mui/material/FormControl';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment-timezone';
import { LocationOn, WindowSharp } from '@mui/icons-material';
import Logo from "assets/images/skill2.png";
import { useLocation } from 'react-router-dom';
import Slider from '@mui/material/Slider';
import editRoutes from "trainingCompanyEditRoutes";
import MKAlert from "components/MKAlert";
import { useNavigate } from 'react-router-dom';
import defaultRoutes from "routes";
import {
    GetCountries,
    GetState,
    GetCity,
    GetLanguages,
} from "react-country-state-city";
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import '../../../styles.css';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';

function valuetext(value) {
    return `${value}`;
}

const sidebarStyles = {
    width: '350px',
    // backgroundColor: 'rgba(0, 0, 50, 0.2)', // Blue with 50% transparency
    padding: '20px',
    color: 'white',
    borderRadius: '15px',
};

const LoadingOverlay = ({ loading, children }) => {
    return (
        <>
            {loading && (
                <Backdrop
                    sx={{
                        color: '#fff',
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                        filter: 'blur(5px)',
                        pointerEvents: 'none',
                    }}
                    open={loading}
                >
                    <Box
                        sx={{
                            position: "absolute",
                            top: "0",
                            left: "0",
                            zIndex: "1",
                            width: "100%",
                            minHeight: "100vh",
                            // display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            pointerEvents: 'none',
                            userSelect: 'none',
                        }}
                    >
                        {children}
                    </Box>
                </Backdrop>
            )}
            {loading && (
                <Box
                    sx={{
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: (theme) => theme.zIndex.drawer + 2,
                    }}
                >
                    <CircularProgress />
                </Box>
            )}
            {!loading && children}
        </>
    );
};

const Page = () => {
    const [modeOfTraining, setModeOfTraining] = useState("");
    const [location, setLocation] = useState("");
    const [budget, setBudget] = useState("");
    const [budgetSliderValue, setBudgetSliderValue] = useState([0, 100000]);
    const [budgetRangeFrom, setBudgetRangeFrom] = useState(0);
    const [budgetRangeTo, setBudgetRangeTo] = useState(100000);
    const [showLocationField, setShowLocationField] = useState(false);
    const [skillsName, setSkillsName] = useState([]);
    const [trainerList, setTrainerList] = useState([]);
    const [bbdata, setbbData] = useState([]);
    const [currentTotalPages, setCurrentTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedTrainer, setSelectedTrainer] = useState([]);
    const [selectedTrainerId, setSelectedTrainerId] = useState("");
    const [avatarBackgroundColor, setAvatarBackgroundColor] = useState('#ccc');
    const [travelWithinCountry, setTravelWithinCountry] = useState("");
    const [differentlyAbled, setDifferentlyAbled] = useState("");
    const [certificationSkill, setCertificationSkill] = useState("");
    const [visa, setVisa] = useState("");
    const [visaCountry, setVisaCountry] = useState("");
    const [rating, setRating] = useState("");
    const [travelOutsideCountry, setTravelOutsideCountry] = useState("");
    const [weekendTraining, setWeekendTraining] = useState("");
    const [individualTraining, setIndividualTraining] = useState("");
    const [recordTraining, setRecordTraining] = useState("");
    const [minYear, setMinYear] = useState(0);
    const [maxYear, setMaxYear] = useState(360);
    const [experienceSliderValue, setExperienceSliderValue] = useState([0, 360]);
    const [ratingMin, setRatingMin] = useState(0);
    const [ratingMax, setRatingMax] = useState(5);
    const [ratingSliderValue, setRatingSliderValue] = useState([0, 5]);
    const [timeZone, setTimeZone] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [minTrainingDelivered, setMinTrainingDelivered] = useState("");
    const [maxTrainingDelivered, setMaxTrainingDelivered] = useState("");
    const [submitCompleted, setSubmitCompleted] = useState(false);
    const [userId, setUserId] = useState("");
    const [loading, setLoading] = useState(false);

    const [trainingCompanyProfileCreate, setTrainingCompanyProfileCreate] = useState(false);
    const [emailVerified, setEmailVerified] = useState(false);
    const [mobVerified, setMobVerified] = useState(false);
    const [tcVerified, setTcVerified] = useState(false);
    const pageSize = 5;

    const [responseRecruitFromDB, setResponseRecruitFromDB] = useState('');
    const [maxRecruitCount, setMaxRecruitCount] = useState(false);

    const minYearOptions = Array.from({ length: 21 }, (_, index) => index);
    const maxYearOptions = Array.from({ length: 21 }, (_, index) => index);

    const minTrainingDeliveredOptions = Array.from({ length: 10 }, (_, index) => index);
    const maxTrainingDeliveredOptions = Array.from({ length: 51 }, (_, index) => index);
    const [trainingCompanyProfileDetails, setTrainingCompanyProfileDetails] = useState([])

    useEffect(() => {
        let id = localStorage.getItem("userId");

        if (id) {
            fetch(`${process.env.REACT_APP_API_URL}/api/training-companyprofile-filter/${id}/`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            })
                .then((resp) => resp.json())
                .then((data) => {
                    if (data.detail) {
                    } else {
                        setTrainingCompanyProfileDetails(data);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }, []);
    console.log("trainingCompanyProfileDetails", trainingCompanyProfileDetails);

    const handleSliderChange = (event, newValues) => {
        const [minValue, maxValue] = newValues;
        setMinYear(minValue);
        setMaxYear(maxValue);
        setExperienceSliderValue(newValues);
    };

    const handleRatingSliderChange = (event, newValues) => {
        const [minValue, maxValue] = newValues;
        setRatingMin(minValue);
        setRatingMax(maxValue);
        setRatingSliderValue(newValues);
    };

    const handleTrainingSliderChange = (event, newValues) => {
        const [minValue, maxValue] = newValues;
        setMinTrainingDelivered(minValue);
        setMaxTrainingDelivered(maxValue);
    };

    const timeZones = moment.tz.names();

    const handleTimeZoneChange = (newValue) => {
        setTimeZone(newValue);
    };
    console.log("timeZone", timeZone);

    const urlPath = useLocation();
    const queryParams = new URLSearchParams(urlPath.search);

    const initialSearchValue = queryParams.get('search');
    const asearch = queryParams.get('search');
    const alocation = queryParams.get('location');
    const abudgetRangeFrom = queryParams.get('budgetRangeFrom');
    const abudgetRangeTo = queryParams.get('budgetRangeTo');

    console.log("hi");
    console.log("search", asearch);
    console.log("location", alocation);
    console.log("budgetRangeFrom", abudgetRangeFrom);
    console.log("budgetRangeTo", abudgetRangeTo);

    const handleBudgetSliderChange = (event, newValues) => {
        const [minValue, maxValue] = newValues;
        setBudgetRangeFrom(minValue);
        setBudgetRangeTo(maxValue);
        setBudgetSliderValue(newValues);
    };


    const [search, setSearch] = useState(initialSearchValue || '');

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/api/skill-details/`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (data.detail) {
                } else {
                    setSkillsName(["ANY", ...data]);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);
    console.log("skillsName", skillsName);

    const handleSearchChange = (event, value) => {
        const typedSkill = event.target.value;
        console.log("typedSkill@@@@@@@@@@@@@", typedSkill);
        if (typedSkill && !skillsName.includes(typedSkill)) {
            fetch(`${process.env.REACT_APP_API_URL}/api/skill-details/?q=${typedSkill}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            })
                .then((resp) => resp.json())
                .then((data) => {
                    setSkillsName([...skillsName, ...data]);
                })
                .catch((error) => {
                    console.error(error);
                });
        }
        setSearch(value);
    };
    console.log("search", search);

    const handleBudgetChange = (e) => {
        const newValue = e.target.value;
        setBudget(newValue);
        if (newValue === "0-1000") {
            setBudgetRangeFrom(0);
            setBudgetRangeTo(1000);
        } else if (newValue === "1000-5000") {
            setBudgetRangeFrom(1000);
            setBudgetRangeTo(5000);
        } else if (newValue === "5000-10000") {
            setBudgetRangeFrom(5000);
            setBudgetRangeTo(10000);
        } else if (newValue === "10000-20000") {
            setBudgetRangeFrom(10000);
            setBudgetRangeTo(20000);
        } else if (newValue === ">20000") {
            setBudgetRangeFrom(20000);
            setBudgetRangeTo('');
        }
    };

    console.log("budget", budget);
    console.log("budgetRangeFrom", budgetRangeFrom);
    console.log("budgetRangeTo", budgetRangeTo);

    const [countryList, setCountryList] = useState([]);
    const [languageList, setLanguageList] = useState([]);

    useEffect(() => {
        GetCountries().then((result) => {
            setCountryList(result);
        });

        GetLanguages().then((result) => {
            setLanguageList(result);
        });
    }, []);


    const [currentLocationCountry, setCurrentLocationCountry] = useState('');
    const [currentLocationState, setCurrentLocationState] = useState('');
    const [currentCountryID, setCurrentCountryID] = useState('');
    const [currentStateList, setCurrentStateList] = useState([]);
    const [currentCityList, setCurrentCityList] = useState([]);
    const handleCurrentLocationCountry = (event) => {
        const selectedCountryIndex = event.target.value;

        if (countryList && countryList.length > selectedCountryIndex) {
            const selectedCountry = countryList[selectedCountryIndex];

            setCurrentLocationCountry(selectedCountry.name);
            setCurrentCountryID(selectedCountry.id);

            GetState(selectedCountry.id).then((result) => {
                setCurrentStateList(result);
            });
        }
    };


    const handleCurrentLocationState = (event) => {
        const selectedStateIndex = event.target.value;

        if (currentStateList && currentStateList.length > selectedStateIndex) {
            const selectedState = currentStateList[selectedStateIndex];

            setCurrentLocationState(selectedState.name);

            GetCity(currentCountryID, selectedState.id).then((result) => {
                setCurrentCityList(result);
            });
        }
    };


    const handleCurrentLocationCity = (event) => {
        const selectedCityIndex = event.target.value;
        const selectedCity = currentCityList[selectedCityIndex];

        setLocation(selectedCity.name);
    };


    const handlePreferredModeChange = (e) => {
        const selectedMode = e.target.value;
        setModeOfTraining(selectedMode);

        if (selectedMode === "Classroom") {
            setShowLocationField(true);
        } else {
            setShowLocationField(false);
        }
    };
    console.log("modeOfTraining", modeOfTraining);

    useEffect(() => {
        const id = localStorage.getItem("userId");
        let technology = search === "ANY" ? "" : search;
        const apiUrl = id
            ? `${process.env.REACT_APP_API_URL}/api/getSearchtech-trainerprofile/${id}/${technology}`
            : `${process.env.REACT_APP_API_URL}/api/getSearchtech-trainerprofile/${technology}`;

        fetch(apiUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (!data.detail) {
                    setbbData(data);
                    setTrainerList(data);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, [search, localStorage.getItem("userId")]);


    console.log("trainerList", trainerList);
    console.log("data", bbdata);

    const totalPages = Math.ceil(trainerList.length / pageSize);

    useEffect(() => {
        if (asearch !== search) {
            setSearch(asearch);
        }

        if (alocation !== location) {
            setLocation(alocation);
        }

        if (abudgetRangeFrom !== budgetRangeFrom) {
            setBudgetRangeFrom(abudgetRangeFrom);
        }

        if (abudgetRangeTo !== budgetRangeTo) {
            setBudgetRangeTo(abudgetRangeTo);
        }

    }, [asearch, alocation]);


    const [sortBy, setSortBy] = useState('');
    const [sortByDropdown, setSortByDropdown] = useState('');

    const openSortByDropdown = (event) => {
        setSortByDropdown(event.currentTarget);
    };

    const closeSortByDropdown = () => {
        setSortByDropdown(null);
    };


    const onClearFilterClick = () => {
        setSearch("");
        setBudget("");
        setBudgetRangeFrom("");
        setBudgetRangeTo("");
        setLocation("");
        setTravelWithinCountry("");
        setTravelOutsideCountry("");
        setWeekendTraining("");
        setIndividualTraining("");
        setMinYear("");
        setMaxYear("");
        setRatingMin("");
        setRatingMax("");
        setTimeZone("");
        setRecordTraining("");
        setDifferentlyAbled("");
        setCertificationSkill("");
        setVisa("");
        setVisaCountry("");
        setCurrentLocationCountry("");
        setCurrentLocationState("");
        setSortBy("");
    };


    useEffect(() => {
        let id = localStorage.getItem("userId");
        setUserId(id);
    }, [localStorage.getItem("token")]);

    console.log("userId", userId);

    const onApplyClick = (trainer) => {
        setLoading(true);
        setMaxRecruitCount(false);
        setSelectedTrainer(trainer);
        // setSelectedTrainerId(trainer.id);
        const data = {
            trainingCompanyID: userId,
            trainerID: trainer.user_id,
            trainingCompanyRecruitStatus: "Yes",
            premiumStatus:trainingCompanyProfileDetails.premiumStatus,
        };
        console.log(JSON.stringify(data));
        fetch(`${process.env.REACT_APP_API_URL}/api/company-recruit-trainer/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
            body: JSON.stringify(data),

        })
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    setSubmitCompleted(false);
                    throw new Error("Response not Submitted. Something went wrong");
                }
            })
            .then((data) => {
                console.log("Response from backend:", data.message);
                if (data.message === "Remainder reached maximum for the day") {
                    setResponseRecruitFromDB(data.message);
                    setMaxRecruitCount(true);
                } else if (data.message === "We have sent you a link to the Trainer to accept your request") {
                    setResponseRecruitFromDB(data.message);
                    setSubmitCompleted(true);
                } else {
                    setResponseRecruitFromDB(data.message);
                    setSubmitCompleted(false);
                }
                setLoading(false);
            })
            .catch((error) => {
                console.log("oooooooooooooooo", error.message);
            });
    };
    console.log("selectedTrainer", selectedTrainer);

    const navigate = useNavigate();

    const onMoreDetails = (training) => {
        console.log("training1111111", training);
        console.log("token111111111", localStorage.getItem("token"));
        if (localStorage.getItem("token") === "" || localStorage.getItem("token") === null) {
            console.log("helloooooooooooooo");
            navigate('/pages/authentication/trainingcompanysign-in', { state: { redirectUrl: `/app/recommendedtrainermoredetails/${training.user_id}/` } });
        } else {
            console.log("aaaaaaaaaaaaaaaaaaaaa");
            navigate(`/app/recommendedtrainermoredetails/${training.user_id}/`);
        }

    };

    const onSubmitClick = async () => {
        const filteredList = filterTrainerList();
        setTrainerList(filteredList);
    };

    const handleSkillSelect = (event, value) => {
        if (value) {
            setCertificationSkill(value);
        } else {
            setCertificationSkill(""); // Handle case when value is cleared
        }
    };

    console.log("certificationSkill", certificationSkill);

    const filterTrainerList = () => {
        const filteredList = trainerList.filter((trainer) => {
            const countryMatch = !currentLocationCountry || trainer.currentLocationCountry === currentLocationCountry;
            const stateMatch = !currentLocationState || trainer.currentLocationState === currentLocationState;
            const travelWithinCountryMatch = !travelWithinCountry || trainer.travelWithInYourCountry === travelWithinCountry;
            const travelOutsideCountryMatch = !travelOutsideCountry || trainer.travelOutSideCountry === travelOutsideCountry;
            const weekendTrainingMatch = !weekendTraining || trainer.weekendTraining === weekendTraining;
            const individualTrainingMatch = !individualTraining || trainer.individualTraining === individualTraining;
            const ratingMinMatch = !ratingMin || trainer.trainerRating >= ratingMin;
            const ratingMaxMatch = !ratingMax || trainer.trainerRating <= ratingMax;
            const minYearMatch = !minYear || trainer.totalExperience >= minYear;
            const maxYearMatch = !maxYear || trainer.totalExperience <= maxYear;
            const timeZoneMatch = !timeZone || trainer.workingTimeZone.includes(timeZone);
            const recordTrainingMatch = !recordTraining || trainer.recordTraining === recordTraining;
            const budgetRangeFromMatch = !budgetRangeFrom || trainer.avgCommercialFor8hrs >= budgetRangeFrom;
            const budgetRangeToMatch = !budgetRangeTo || trainer.avgCommercialFor8hrs <= budgetRangeTo;
            const certificationsArray = Array.isArray(trainer.certifications) ? trainer.certifications : [];
            const certificationSkillMatch = !certificationSkill || certificationsArray.some(certification => {
                return certification.technology.toLowerCase().includes(certificationSkill.toLowerCase());
            });

            const visaArray = trainer.personalDetails || "";
            const visaMatch = !visa || visaArray.visa === visa;
            const visaCountryMatch = !visaCountry || visaArray?.visaInfo?.some(info => info.country === visaCountry);

            return (
                countryMatch &&
                stateMatch &&
                travelWithinCountryMatch &&
                travelOutsideCountryMatch &&
                weekendTrainingMatch &&
                individualTrainingMatch &&
                budgetRangeFromMatch &&
                budgetRangeToMatch &&
                minYearMatch &&
                maxYearMatch &&
                ratingMinMatch &&
                ratingMaxMatch &&
                timeZoneMatch &&
                recordTrainingMatch &&
                certificationSkillMatch &&
                visaMatch &&
                visaCountryMatch
            );
        });
        const sortedList = filteredList.sort(compareFunction);

        return sortedList;
    };

    const compareFunction = (a, b) => {
        if (sortBy === 'Commercials - Low to High') {
            return a.avgCommercialFor8hrs - b.avgCommercialFor8hrs;
        } else if (sortBy === 'Commercials - High to Low') {
            return b.avgCommercialFor8hrs - a.avgCommercialFor8hrs;
        } else if (sortBy === 'Rating - Low to High') {
            return a.trainerRating - b.trainerRating;
        } else if (sortBy === 'Rating - High to Low') {
            return b.trainerRating - a.trainerRating;
        }
        return 0;
    };

    const getCurrentPageData = () => {
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        return filterTrainerList().slice(startIndex, endIndex);
    };

    const handleNextClick = () => {
        const totalPages = Math.ceil(filterTrainerList().length / pageSize);
        // setCurrentTotalPages(totalPages);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrevClick = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };


    useEffect(() => {
        const totalPages = Math.ceil(filterTrainerList().length / pageSize);
        setCurrentTotalPages(totalPages);
    }, [filterTrainerList()]);


    const handleSortBySelect = (salutation) => {
        setSortBy(salutation);
        console.log('Selected Salutation:', salutation);
        closeSortByDropdown();
    };

    const handleTrainerConnectOK = () => {
        setSubmitCompleted(false);
        window.location.reload();
    };

    useEffect(() => {
        const id = localStorage.getItem("userId");

        if (id) {
            // Make the userdetails API call
            fetch(`${process.env.REACT_APP_API_URL}/api/userdetails/${id}/`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            })
                .then((resp) => resp.json())
                .then((data) => {
                    if (!data.detail) {
                        setEmailVerified(data.is_verified);
                        setMobVerified(data.is_verified_mobile);
                        setTcVerified(data.is_verified_tc);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });

            // Make the trainingcompanyprofileuidexists API call
            fetch(`${process.env.REACT_APP_API_URL}/api/trainingcompanyprofileuidexists/${id}/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + localStorage.getItem('token'),
                },
            })
                .then((resp) => resp.json())
                .then((data) => {
                    if (data.exists === false && mobVerified === true && tcVerified === true && emailVerified === true) {
                        setTrainingCompanyProfileCreate(true);
                        window.location.href = "/app/trainingcompanyprofile";
                    } else {
                        setTrainingCompanyProfileCreate(false);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }, [localStorage.getItem("userId"), mobVerified, tcVerified, emailVerified, responseRecruitFromDB]);

    console.log("trainingCompanyProfileCreate", trainingCompanyProfileCreate);


    return (
        <>
            <LoadingOverlay loading={loading}>
                <DefaultNavbar
                    routes={localStorage.getItem("userId") ? (trainingCompanyProfileCreate ? routes : editRoutes) : defaultRoutes}
                    sticky
                />
                <Card
                    sx={{
                        height: 'auto',
                        p: 2,
                        mx: { xs: 2, lg: 3 },
                        mt: -8,
                        mb: 4,
                        // backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
                        backdropFilter: "saturate(200%) blur(30px)",
                        boxShadow: ({ boxShadows: { xxl } }) => xxl,
                    }}
                >
                    <Dialog
                        open={submitCompleted}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            Notification !
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Your response has been sent to the trainer.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                            <MKButton variant="gradient" onClick={handleTrainerConnectOK} color="info" autoFocus>
                                OK
                            </MKButton>
                        </DialogActions>
                    </Dialog>
                    <Container maxWidth="sm">
                        <form>
                            <Grid container style={{ marginTop: "130px" }} spacing={2}>
                                <Grid item xs={12} sm={3}>
                                    <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h2" color="text">
                                        <span style={{ color: 'black' }}>Search</span>{' '}
                                        <span style={{ color: '#2e1114' }}>Trainer</span>
                                    </MKTypography>
                                </Grid>
                            </Grid>
                            <Grid container style={{ marginTop: '0px' }} spacing={2}>
                                <Grid item xs={12} sm={9}>
                                    <div>
                                        <Typography variant="h5" style={{ color: 'black' }}>Search by Skills</Typography>
                                        <Autocomplete
                                            id="skills"
                                            options={skillsName}
                                            value={search}
                                            freeSolo
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Skill"
                                                    variant="standard"
                                                    style={{ marginTop: '10px' }}
                                                    fullWidth
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <SearchIcon fontSize="medium" />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            )}
                                            onChange={(event, value) => handleSearchChange(event, value)}
                                        />
                                    </div>
                                </Grid>
                            </Grid>

                            <Container>
                                <Grid container>
                                    <Grid item xs={4} style={{ marginLeft: '-50px' }}>
                                        <div style={sidebarStyles}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <Typography variant="h5" style={{ color: 'black', marginLeft: '8px' }}>Filters</Typography>
                                                {/* <Link href="#" onClick={onClearFilterClick} style={{ marginLeft: '65px', textDecoration: 'underline', color: 'blue', cursor: 'pointer', fontSize: 'small' }}>
                                                Clear Filters
                                            </Link> */}
                                                <MKButton variant="gradient" color="info" size="small" style={{ marginLeft: '65px', whiteSpace: 'nowrap' }} onClick={onClearFilterClick} >Clear Filters</MKButton>
                                                <MKButton variant="gradient" color="info" size="small" style={{ marginRight: '10px' }} onClick={onSubmitClick} >Submit</MKButton>
                                            </div>
                                            <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                <FormControl variant="outlined" style={{ width: '300px' }}>
                                                    <InputLabel id="country-select">Country *</InputLabel>
                                                    <Select
                                                        labelId="country"
                                                        label="Country"
                                                        fullWidth
                                                        onChange={handleCurrentLocationCountry}
                                                        value={countryList.findIndex((country) => country.name === currentLocationCountry)}
                                                        style={{ minHeight: '44px' }}
                                                    >
                                                        {countryList.map((country, index) => (
                                                            <MenuItem key={index} value={index}>
                                                                {country.name}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                <FormControl variant="outlined" style={{ width: '300px' }}>
                                                    <InputLabel id="state-select">State *</InputLabel>
                                                    <Select
                                                        labelId="state"
                                                        label="State"
                                                        fullWidth
                                                        onChange={handleCurrentLocationState}
                                                        value={currentStateList.findIndex((state) => state.name === currentLocationState)}
                                                        style={{ minHeight: '44px' }}
                                                    >
                                                        {currentStateList.map((state, index) => (
                                                            <MenuItem key={index} value={index}>
                                                                {state.name}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                <FormControl variant="outlined" style={{ width: '300px' }}>
                                                    <InputLabel id="city-select">City *</InputLabel>
                                                    <Select
                                                        labelId="city"
                                                        label="City"
                                                        fullWidth
                                                        onChange={handleCurrentLocationCity}
                                                        value={currentCityList.findIndex((city) => city.name === location)}
                                                        style={{ minHeight: '44px' }}
                                                    >
                                                        {currentCityList.map((city, index) => (
                                                            <MenuItem key={index} value={index}>
                                                                {city.name}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <Typography style={{ marginLeft: '10px', marginRight: '20px', marginTop: '10px' }} variant="h6">Budget</Typography>
                                            <div style={{ marginLeft: '10px', marginTop: '10px', padding: '10px' }}>
                                                <Slider
                                                    value={budgetSliderValue}
                                                    onChange={handleBudgetSliderChange}
                                                    size="small"
                                                    getAriaValueText={valuetext}
                                                    valueLabelDisplay="auto"
                                                    aria-labelledby="range-slider"
                                                    max={100000}
                                                />
                                            </div>
                                            <div style={{ marginLeft: '10px', adding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                <TextField
                                                    label="Min"
                                                    variant="outlined"
                                                    style={{ width: '100px' }}
                                                    fullWidth
                                                    onChange={(e) => setBudgetRangeFrom(e.target.value)}
                                                    value={budgetRangeFrom}
                                                    InputProps={{ inputProps: { min: 1000, max: 100000 } }}
                                                    type="number"
                                                />
                                                <TextField
                                                    label="Max"
                                                    variant="outlined"
                                                    style={{ marginRight: '10px', width: '100px' }}
                                                    fullWidth
                                                    onChange={(e) => setBudgetRangeTo(e.target.value)}
                                                    value={budgetRangeTo}
                                                    InputProps={{ inputProps: { min: 1000, max: 100000 } }}
                                                    type="number"
                                                />
                                            </div>
                                            <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel id="travel-withinCountry-label">Travel within the country</InputLabel>
                                                    <Select
                                                        labelId="travel-withinCountry-label"
                                                        label="Travel within the country"
                                                        fullWidth
                                                        onChange={(e) => setTravelWithinCountry(e.target.value)}
                                                        value={travelWithinCountry}
                                                        style={{ minHeight: '44px' }}
                                                    >
                                                        <MenuItem value="">Select</MenuItem>
                                                        <MenuItem value="yes">Yes</MenuItem>
                                                        <MenuItem value="no">No</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel id="travel-outsideCountry-label">Travel outside the country</InputLabel>
                                                    <Select
                                                        labelId="travel-outsideCountry-label"
                                                        label="Travel outside the country"
                                                        fullWidth
                                                        onChange={(e) => setTravelOutsideCountry(e.target.value)}
                                                        value={travelOutsideCountry}
                                                        style={{ minHeight: '44px' }}
                                                    >
                                                        <MenuItem value="">Select</MenuItem>
                                                        <MenuItem value="yes">Yes</MenuItem>
                                                        <MenuItem value="no">No</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel id="weekend-training-label">Weekend Training</InputLabel>
                                                    <Select
                                                        labelId="weekend-Training-label"
                                                        label="Weekend Training"
                                                        fullWidth
                                                        onChange={(e) => setWeekendTraining(e.target.value)}
                                                        value={weekendTraining}
                                                        style={{ minHeight: '44px' }}
                                                    >
                                                        <MenuItem value="">Select</MenuItem>
                                                        <MenuItem value="yes">Yes</MenuItem>
                                                        <MenuItem value="no">No</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel id="individual-training-label">Individual Training</InputLabel>
                                                    <Select
                                                        labelId="individual-Training-label"
                                                        label="Individual Training"
                                                        fullWidth
                                                        onChange={(e) => setIndividualTraining(e.target.value)}
                                                        value={individualTraining}
                                                        style={{ minHeight: '44px' }}
                                                    >
                                                        <MenuItem value="">Select</MenuItem>
                                                        <MenuItem value="yes">Yes</MenuItem>
                                                        <MenuItem value="no">No</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel id="record-training-label">Record Training</InputLabel>
                                                    <Select
                                                        labelId="record-Training-label"
                                                        label="Record Training"
                                                        fullWidth
                                                        onChange={(e) => setRecordTraining(e.target.value)}
                                                        value={recordTraining}
                                                        style={{ minHeight: '44px' }}
                                                    >
                                                        <MenuItem value="">Select</MenuItem>
                                                        <MenuItem value="yes">Yes</MenuItem>
                                                        <MenuItem value="no">No</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel id="visa-label">Visa</InputLabel>
                                                    <Select
                                                        labelId="visa-label"
                                                        label="Visa"
                                                        fullWidth
                                                        onChange={(e) => setVisa(e.target.value)}
                                                        value={visa}
                                                        style={{ minHeight: '44px' }}
                                                    >
                                                        <MenuItem value="">Select</MenuItem>
                                                        <MenuItem value="yes">Yes</MenuItem>
                                                        <MenuItem value="no">No</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            {visa === "yes" && (
                                                <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                    <FormControl variant="outlined" style={{ width: '350px' }}>
                                                        <InputLabel id="country-select">Country</InputLabel>
                                                        <Select
                                                            labelId="country"
                                                            label="Country"
                                                            fullWidth
                                                            onChange={(e) => setVisaCountry(e.target.value)}
                                                            value={visaCountry}
                                                            style={{ minHeight: '44px' }}
                                                        >
                                                            {CountryList.getAll().map((country) => (
                                                                <MenuItem key={country.name} value={country.name}>
                                                                    {country.name}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            )}
                                            <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                <Autocomplete
                                                    // multiple
                                                    id="timeZone-autocomplete"
                                                    options={timeZones}
                                                    freeSolo
                                                    renderTags={(value, getTagProps) =>
                                                        value.map((option, tagIndex) => (
                                                            <span key={tagIndex} {...getTagProps({ index: tagIndex })}>
                                                                {option}
                                                            </span>
                                                        ))
                                                    }
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Working Time Zone"
                                                            variant="outlined"
                                                            style={{ minHeight: '40px', width: '290px' }}
                                                            fullWidth
                                                        />
                                                    )}
                                                    onChange={(event, value) => handleTimeZoneChange(value)}
                                                />
                                            </div>
                                            <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                <div>
                                                    <Autocomplete
                                                        id={`skills`}
                                                        options={skillsName}
                                                        freeSolo
                                                        renderTags={(value, getTagProps) =>
                                                            value.map((option, index) => (
                                                                <span key={index} {...getTagProps({ index })}>
                                                                    {option}
                                                                </span>
                                                            ))
                                                        }
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Certification ('s)"
                                                                variant="outlined"
                                                                style={{ width: '290px' }}
                                                                helperText="Select the Technology name"
                                                                fullWidth
                                                            />
                                                        )}
                                                        value={certificationSkill}
                                                        onChange={handleSkillSelect}
                                                    />
                                                </div>
                                            </div>
                                            <Typography style={{ marginLeft: '10px', marginRight: '20px', marginTop: '10px' }} variant="h6">Rating</Typography>
                                            <div style={{ marginLeft: '10px', marginTop: '10px', padding: '10px' }}>
                                                <Slider
                                                    value={ratingSliderValue}
                                                    onChange={handleRatingSliderChange}
                                                    size="small"
                                                    getAriaValueText={valuetext}
                                                    valueLabelDisplay="auto"
                                                    aria-labelledby="range-slider"
                                                    max={5}
                                                />
                                            </div>
                                            <div style={{ marginLeft: '10px', adding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                <TextField
                                                    label="Min"
                                                    variant="outlined"
                                                    style={{ width: '100px' }}
                                                    fullWidth
                                                    onChange={(e) => setRatingMin(e.target.value)}
                                                    value={ratingMin}
                                                    InputProps={{ inputProps: { min: 0, max: 5 } }}
                                                    type="number"
                                                />
                                                <TextField
                                                    label="Max"
                                                    variant="outlined"
                                                    style={{ marginRight: '10px', width: '100px' }}
                                                    fullWidth
                                                    onChange={(e) => setRatingMax(e.target.value)}
                                                    value={ratingMax}
                                                    InputProps={{ inputProps: { min: 0, max: 5 } }}
                                                    type="number"
                                                />
                                            </div>

                                            <Typography style={{ marginLeft: '10px', marginRight: '20px', marginTop: '10px' }} variant="h6">Total Experience (in months)</Typography>
                                            <div style={{ marginLeft: '10px', marginTop: '10px', padding: '10px' }}>
                                                <Slider
                                                    value={experienceSliderValue}
                                                    onChange={handleSliderChange}
                                                    size="small"
                                                    getAriaValueText={valuetext}
                                                    valueLabelDisplay="auto"
                                                    aria-labelledby="range-slider"
                                                    max={360}
                                                />
                                            </div>
                                            <div style={{ marginLeft: '10px', adding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                <TextField
                                                    label="Min"
                                                    variant="outlined"
                                                    style={{ width: '100px' }}
                                                    fullWidth
                                                    onChange={(e) => setMinYear(e.target.value)}
                                                    value={minYear}
                                                    InputProps={{ inputProps: { min: 0, max: 360 } }}
                                                    type="number"
                                                />
                                                <TextField
                                                    label="Max"
                                                    variant="outlined"
                                                    style={{ marginRight: '10px', width: '100px' }}
                                                    fullWidth
                                                    onChange={(e) => setMaxYear(e.target.value)}
                                                    value={maxYear}
                                                    InputProps={{ inputProps: { min: 0, max: 360 } }}
                                                    type="number"
                                                />
                                            </div>

                                        </div>
                                    </Grid>

                                    <Grid item xs={8}>
                                        <Grid container style={{ marginTop: '10px', marginBottom: '10px' }} spacing={2}>
                                            <Grid item xs={12} sm={3}>
                                                <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h6" color="dark">
                                                    {filterTrainerList() ? `${filterTrainerList().length} result${filterTrainerList().length !== 1 ? 's' : ''} found` : 'Default Training Name'}
                                                </MKTypography>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} sm={3} style={{ display: 'flex', justifyContent: 'flex-end', marginLeft: '340px', marginTop: '-43px', marginBottom: '20px' }}>
                                            <div >
                                                <MKButton style={{ whiteSpace: 'nowrap' }} variant="gradient" color="info" size="small" onClick={openSortByDropdown}>
                                                    {sortBy || 'Sort by'} <Icon>expand_more</Icon>
                                                </MKButton>
                                                <Menu anchorEl={sortByDropdown} open={Boolean(sortByDropdown)} onClose={closeSortByDropdown}>
                                                    <MenuItem onClick={() => handleSortBySelect('Commercials - Low to High')}>Commercials - Low to High</MenuItem>
                                                    <MenuItem onClick={() => handleSortBySelect('Commercials - High to Low')}>Commercials - High to Low</MenuItem>
                                                    <MenuItem onClick={() => handleSortBySelect('Rating - Low to High')}>Rating - Low to High</MenuItem>
                                                    <MenuItem onClick={() => handleSortBySelect('Rating - High to Low')}>Rating - High to Low</MenuItem>
                                                </Menu>
                                            </div>
                                        </Grid>
                                        <Grid item xs={12} sm={8}>
                                            {maxRecruitCount && (
                                                <MKAlert color="error" dismissible>
                                                    You've reached the daily recruit limit!
                                                </MKAlert>
                                            )}
                                        </Grid>
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            {getCurrentPageData().map((trainer, index) => (
                                                <Grid item xs={8} key={trainer.id} className="gridItem" style={{ marginBottom: '20px' }}>
                                                    <div className="gridContent">
                                                        <div className="trainingInfo">
                                                            <div style={{ fontWeight: 'bold', marginTop: '-15px', marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
                                                                <MKAvatar
                                                                    src={`${process.env.REACT_APP_API_URL}${trainer.profilePictureName}/`}
                                                                    alt="Profile Picture"
                                                                    size="lg"
                                                                    style={{ backgroundColor: avatarBackgroundColor, marginRight: '10px' }}
                                                                />
                                                                <Typography variant="subtitle1" className="trainingName" style={{ marginTop: '10px' }}>
                                                                    <strong>{trainer.firstName}&nbsp;{trainer.lastName}</strong>
                                                                </Typography>
                                                            </div>
                                                            <Typography style={{ fontSize: 'medium' }}>
                                                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <LocationOn style={{ marginRight: '5px' }} /> {trainer.currentLocationCountry} | {trainer.currentLocationState}  | {trainer.location}
                                                                </span>
                                                            </Typography>
                                                            <Typography style={{ fontSize: 'medium' }}>
                                                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <img src={Logo} alt="Skills Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {trainer.displaySkills}
                                                                </span>
                                                            </Typography>
                                                            <Typography style={{ fontSize: 'medium' }}>
                                                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginLeft: "5px" }}>Total Experience (in months) :&nbsp;</strong>{trainer.totalExperience} months
                                                                </span>
                                                            </Typography>
                                                            <Typography style={{ fontSize: 'medium' }}>
                                                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginLeft: "5px" }}>Avg per hour Commercial :&nbsp;</strong>{trainer.currency}&nbsp;{trainer.avgCommercialFor8hrs}
                                                                </span>
                                                            </Typography>
                                                            <Typography style={{ fontSize: 'medium' }}>
                                                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginLeft: '5px', marginBottom: '-3px' }}>Rating</strong>&nbsp;
                                                                    <Stack spacing={1} style={{ marginLeft: '5px' }}>
                                                                        <Rating
                                                                            name="read-only"
                                                                            value={trainer.trainerRating}
                                                                            precision={0.5}
                                                                            readOnly
                                                                        />
                                                                    </Stack>
                                                                </span>
                                                            </Typography>
                                                        </div>

                                                        <div>
                                                            {localStorage.getItem("userId") ? (
                                                                <div>
                                                                    <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
                                                                        <MKButton variant="gradient" color="info" size="small" onClick={() => onMoreDetails(trainer)} style={{ padding: '5px 10px' }}>
                                                                            Details
                                                                        </MKButton>
                                                                    </div>
                                                                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                                                        <MKButton variant="gradient" color="info" size="small" onClick={() => onApplyClick(trainer)} style={{ padding: '5px 10px' }}>
                                                                            Connect
                                                                        </MKButton>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-40px' }}>
                                                                    <MKButton variant="gradient" color="info" size="small" onClick={() => onMoreDetails(trainer)} style={{ padding: '5px 10px' }}>
                                                                        Details
                                                                    </MKButton>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </Grid>
                                            ))}
                                            <div style={{ marginTop: '10px', marginLeft: '-280px', display: 'flex', justifyContent: 'center' }}>
                                                <MKButton onClick={handlePrevClick} color="info" variant="gradient" size="small" disabled={currentPage === 1}>
                                                    <Icon>keyboard_arrow_left</Icon>
                                                </MKButton>
                                                {Array.from({ length: currentTotalPages }).map((_, index) => (
                                                    <MKButton
                                                        key={index}
                                                        onClick={() => setCurrentPage(index + 1)}
                                                        variant={currentPage === index + 1 ? 'gradient' : 'gradient'}
                                                        color="info"
                                                        size="small"
                                                    >
                                                        {index + 1}
                                                    </MKButton>
                                                ))}
                                                <MKButton onClick={handleNextClick} variant="gradient" color="info" size="small" disabled={currentPage === totalPages}>
                                                    <Icon>keyboard_arrow_right</Icon>
                                                </MKButton>
                                            </div>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Container>
                        </form>
                    </Container>
                </Card>
                <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <MKBox position="center" zIndex={2} style={{ bottom: 0 }}>
                        <SimpleFooter />
                    </MKBox>
                </div>
            </LoadingOverlay>
        </>
    );
}

export default Page;